module.exports = __webpack_public_path__ + "img/login_l.62e47d22.png";